import React from 'react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface ThemedCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const ThemedCard: React.FC<ThemedCardProps> = ({ className, children, ...props }) => {
  return (
    <Card
      className={cn(
        "bg-transparent border-wedding-pink/30 shadow-lg",
        className
      )}
      {...props}
    >
      {children}
    </Card>
  );
};

export default ThemedCard;
